import { render, staticRenderFns } from "./dropzone-manager.vue?vue&type=template&id=ffd70c8c"
import script from "./dropzone-manager.js?vue&type=script&lang=js&external"
export * from "./dropzone-manager.js?vue&type=script&lang=js&external"
import style0 from "./dropzone-manager.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports